import { find } from 'lodash';
import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_FETCHING = 'SET_FETCHING';
export const SET_STOP_FETCHING = 'SET_STOP_FETCHING';
export const SET_ABSENCE_REASONS = 'SET_ABSENCE_REASONS';

const data = {
  absenceReasons: [],
  currentAbsenceReason: {},
  fetching: false,
  absenceReasonsTotal: 0,
  pageSizeDefault: undefined,
};

const actions = {
  async loadAbsenceReasons({ commit }) {
    const absenceReasons = await api.getAbsenceReasons();
    commit(SET_ABSENCE_REASONS, { absenceReasons });
  },
  async loadAbsenceReasonsPagination({ commit }, { page, pageSize, moreData = false }) {
    commit(SET_FETCHING);
    return api.getAbsenceReasonsPagination(page, pageSize).then((res) => {
      commit(SET_ABSENCE_REASONS, {
        absenceReasons: res.absenceReasons,
        total: res.totalCount,
        moreData,
        pageSizeDefault: res.pageSize,
      });
      return res;
    }).catch((err) => {
      commit(SET_STOP_FETCHING);
      throw err;
    });
  },
  async getAbsenceReason({ dispatch, state }, { id }) {
    let absenceReason = find(state.absenceReasons, (reason) => reason.id === id);
    if (!absenceReason) { absenceReason = await api.getAbsenceReason({ id }); }
    dispatch('setCurrentAbsenceReason', absenceReason);
    return absenceReason;
  },
  setCurrentAbsenceReason({ commit }, value) {
    commit('SET_CURRENT_ABSENCE_REASON', value);
  },
  createAbsenceReason(_, absenceReasonParams) {
    return api.createAbsenceReason(absenceReasonParams).then((res) => res);
  },
  updateAbsenceReason(_, absenceReasonParams) {
    const {
      id,
      absenceReason,
    } = absenceReasonParams;
    return api.updateAbsenceReason(id, absenceReason).then((res) => res);
  },
  async deleteAbsenceReason({ commit, state }, id) {
    const result = await api.deleteAbsenceReason({ id });
    if (result) {
      const absenceReasons = state.absenceReasons
        .filter((absenceReason) => absenceReason.id !== id);
      commit(SET_ABSENCE_REASONS, { absenceReasons, total: state.absenceReasonsTotal - 1 });
    }
    return result;
  },
};

const mutations = {
  SET_ABSENCE_REASONS(state, {
    absenceReasons, total, moreData, pageSizeDefault,
  }) {
    state.pageSizeDefault = pageSizeDefault || state.pageSizeDefault;
    if (moreData) {
      state.absenceReasons = state.absenceReasons.concat(absenceReasons);
    } else {
      state.absenceReasons = absenceReasons;
    }
    state.absenceReasonsTotal = total || state.absenceReasonsTotal;
    mutations.SET_STOP_FETCHING(state);
  },
  SET_FETCHING(state) {
    state.fetching = true;
  },
  SET_STOP_FETCHING(state) {
    state.fetching = false;
  },
  SET_CURRENT_ABSENCE_REASON(state, value) {
    state.currentAbsenceReason = value;
  },
};

const store = {
  state: data,
  actions,
  mutations,
  namespaced: true,
};

export default store;
